@import '~less/global-variables';
@import '~less/layout/typography';

/**
 * Sidebar navigation
 *
 * Used for instance at FAQ page
 */

.sidebar {
  .font-brand-regular();

  // Accordion-style panels and .list-group inside .sidebar
  // http://getbootstrap.com/components/#list-group
  .panel .panel-heading {
    border-bottom: 0;
    margin-bottom: 0;
  }
  .panel-body {
    padding: 0;
  }
  .panel-title {
    font-size: 20px;
  }
  .list-group {
    margin-bottom: 0;
  }
  .list-group-item {
    border: 0;
  }
}
